import { render, staticRenderFns } from "./SkuForm.vue?vue&type=template&id=732433c3&scoped=true&"
import script from "./SkuForm.vue?vue&type=script&lang=js&"
export * from "./SkuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732433c3",
  null
  
)

export default component.exports